import React from 'react';

export default (title, message) => (
	<div>
		<h4 style={{"marginTop":"0px","fontSize":"18px","fontWeight":"bold","marginBottom":"0px"}}>{title}</h4>
		<p style={{"lineHeight":"16px","marginBottom":"8px"}}>{message}</p>
	</div>
);